import { render } from "./RegisterForm.vue?vue&type=template&id=6f173c3c&scoped=true&ts=true"
import script from "./RegisterForm.vue?vue&type=script&lang=ts"
export * from "./RegisterForm.vue?vue&type=script&lang=ts"

import "./RegisterForm.vue?vue&type=style&index=0&id=6f173c3c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f173c3c"]])

export default __exports__